import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";
import TextButton from "@/components/common/buttons/textButton";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { MedspaInfoQueryResult } from "@/graphql/queries/medspaInfo.graphql.types";
import { formattedPrice } from "@/utils";
import { formattedTime } from "@/utils/date";

export default function ServiceDetails({
  service,
  disabled,
}: {
  service: MedspaInfoQueryResult["data"]["medspa"][0]["serviceMenuItems"][0];
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);

  const { durationInMinutes, price, description, isVariablePricing } = service;
  const { showServicePriceOnBooking } = useClientBookingContext();

  const handleButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setOpen(!open);
    e.stopPropagation();
  };

  const textColor = disabled ? "gray.light" : "secondary.main";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="paragraphSmall"
          sx={{
            mr: 1,
            color: textColor,
            whiteSpace: "nowrap",
          }}
        >
          {formattedTime(durationInMinutes)}
        </Typography>
        {showServicePriceOnBooking && (
          <>
            <Typography
              variant="paragraphSmall"
              sx={{
                mr: 1,
                color: textColor,
                whiteSpace: "nowrap",
              }}
            >
              •
            </Typography>
            <Typography
              variant="paragraphSmall"
              sx={{
                mr: 1.5,
                color: textColor,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {formattedPrice(price, isVariablePricing)}
            </Typography>
          </>
        )}

        {description && (
          <TextButton
            sx={{
              visibility: open ? "hidden" : "visible",
              height: open ? 0 : "auto",
            }}
            onClick={handleButtonClick}
          >
            Show description
          </TextButton>
        )}
      </Box>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        aria-label="Show description"
      >
        <Typography
          variant="paragraphSmall"
          sx={{
            color: textColor,
            mt: 1,
          }}
        >
          {description}
        </Typography>
        <TextButton
          sx={{
            whiteSpace: "nowrap",
            mt: 1,
            visibility: open ? "visible" : "hidden",
            height: open ? "auto" : 0,
          }}
          onClick={handleButtonClick}
        >
          Hide description
        </TextButton>
      </Collapse>
    </>
  );
}
